var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "list" },
        [
          _vm._l(_vm.list, function (profile) {
            return _c("profile-item", {
              key: profile.id,
              staticClass: "item",
              attrs: { profile: profile },
              on: {
                remove: function ($event) {
                  return _vm.$emit("removeItem", profile)
                },
              },
            })
          }),
          _c("observer", {
            staticClass: "list-observer",
            on: {
              fullyVisible: function ($event) {
                return _vm.$emit("nextPage")
              },
            },
          }),
        ],
        2
      ),
      _vm.loading
        ? _c("c-loader", {
            staticClass: "loader",
            attrs: {
              active: _vm.loading,
              label: "Анкеты загружаются",
              height: 450,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }